module.exports = __webpack_public_path__ + "img/imgshangzz.9eb8fae8.png";